import { Image } from '@chakra-ui/react';

export const RevivalLogo = () => {
  return (
    <Image
      src={'/mens-womens-revival-logo.png'}
      alt="Men's Women's Revival Logo"
      width="100%"
      height="100%"
      objectFit="contain"
    />
  );
};
